import { render, staticRenderFns } from "./MindView.vue?vue&type=template&id=0fca19e8&scoped=true"
import script from "./MindView.vue?vue&type=script&lang=js"
export * from "./MindView.vue?vue&type=script&lang=js"
import style0 from "./MindView.vue?vue&type=style&index=0&id=0fca19e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca19e8",
  null
  
)

export default component.exports